import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiReadAdminPollQuestionOption = (question_id) => {
    return useQuery({
        queryKey: ['admin', 'poll', 'get', 'option', question_id],
        queryFn: () => ((async (question_id) => {
            return generalRequest.get(`/admin/poll/question_option/${question_id}`)
        })(question_id)),
    })
}


export function useApiCreateAdminPollQuestionOption() {
    return useMutation({
        mutationFn: ({question_id, data}) =>
            ((async (question_id, data = {}) => {
                return generalRequest.post(`/admin/poll/question_option/${question_id}`, data)
            })(question_id, data))
    });

}


export function useApiUpdateAdminPollQuestionOption() {
    return useMutation({
        mutationFn: ({question_id, data}) =>
            ((async (question_id, option_id, data = {}) => {
                return generalRequest.put(`/admin/poll/question_option/${question_id}/${option_id}`, data)
            })(question_id, data))
    });

}


export function useApiDeleteAdminPollQuestionOptions() {
    return useMutation({
        mutationFn: ({question_id, option_id}) =>
            ((async (question_id, option_id) => {
                return generalRequest.delete(`/admin/poll/question_option/${question_id}/${option_id}`)
            })(question_id, option_id))
    });

}

